import { NgForm } from '@angular/forms';
import { Component, OnInit, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { Subscription } from 'rxjs';
import { AccountService } from '../../../services/account.service';
import { fadeInOut } from '../../../services/animations';
import { AlertService, MessageSeverity } from '../../../services/alert.service';
import { Utilities } from '../../../services/utilities';
import { Permission } from '../../../models/permission.model';
import * as moment from 'moment';
import { GasThree } from '../../../models/gasthree.model';
import { GasThreeService } from '../../../services/gasthree.service';
import { forEach } from '@angular/router/src/utils/collection';

@Component({
    selector: 'gasthree-add-update',
    template: require('./gasthree-add-update.component.html'),
    styles: [require('./gasthree-add-update.component.css')],
    animations: [fadeInOut]
})
export class GasThreeAddUpdateComponent implements OnInit, OnDestroy {

    private subscribers: Subscription[] = [];

    mode: string = "Opslaan";
    gasthree: GasThree = new GasThree;     
    eanCodes: any[] = [];
    loading: boolean = false;
    display1: boolean = false;
    display2: boolean = false;
    selectedData: any; 
    date = new Date();
    ddlKwartaal: [string, string][] = [
        ['Jan,Feb,Mar,', 'Kwartaal 1'],
        ['Apr,May,Jun,', 'Kwartaal 2'],
        ['Jul,Aug,Sep,', 'Kwartaal 3'],
        ['Oct,Nov,Dec,', 'Kwartaal 4']];
    selectedKwartaal: string;
    selectedYear: number;
    years: [number, number][] = [];
    ddYears: [number, number][] = [];
    isDisableControl: boolean = false;
    location: boolean = true;
    location1: boolean = false;
    EditValue: any;

    constructor(private accountService: AccountService, private gasthreeService: GasThreeService,
        private router: Router, private activatedRoute: ActivatedRoute, private alertService: AlertService, private ngxLogger: NGXLogger) {
        this.getYears();
    }

    ngOnInit() {
        this.activatedRoute.params.subscribe(params => {
            if (params['id']) {
                this.gasthree.Id = params['id'];
                this.getById();
                this.isDisableControl = true;
                this.location = false;
                this.location1 = true;
            }
        });        
    }

    private getYears() {
        this.gasthreeService.getCurrentYear().subscribe((currentYear: number) => {
            if (currentYear) {
                let year = currentYear - 1;
                this.years.push([year, +(year.toString().substring(2, 4))]);
                year = currentYear;
                this.years.push([year, +(year.toString().substring(2, 4))]);
                year = currentYear + 1;
                this.years.push([year, +(year.toString().substring(2, 4))]);

                this.ddYears = [...this.years];
            }
        }, error => {
            this.ngxLogger.error(error.message);
            throw error;
        });
    }

    private getKwartaalFromStripName() {        
        if (this.gasthree && this.gasthree.StripName) {
            let Kwartaal = this.gasthree.StripName.substring(0, 3);
            let c='';
            this.ddlKwartaal.filter(function (node) {                
                let a = node[0].split(',');
                let b = a.forEach(childObj => {
                    if (childObj == Kwartaal) {
                        c = node[0].toString();                 
                    }
                })                               
            });
            this.selectedKwartaal = c;
            const stripYear = +this.gasthree.StripName.substring(3, this.gasthree.StripName.length);
            if (!this.ddYears.some(s => s[1] === stripYear)) {
                this.ddYears = [];
                this.ddYears = [...this.years];
                const currentYear = new Date().getFullYear();
                const twoCharCurrentYear = +(currentYear.toString().substring(0, 2));
                this.ddYears.splice(0, 0, [+(twoCharCurrentYear + '' + stripYear), stripYear]);
            }
            this.selectedYear = stripYear;
        }
    }

    createUpdate(f: NgForm) {        
        if (f.form.valid) {
            
            this.gasthree.StripName = this.selectedKwartaal + this.selectedYear;             
            this.gasthreeService.createUpdate(this.gasthree).subscribe((res: GasThree) => {
                if (res) {                    
                    if (res.StripName != 'Duplicate') {
                        this.alertService.showMessage('Gas TTF 103', 'Aanpassingen met succes bewaard!', MessageSeverity.success);
                        this.router.navigate(['gasthree']);
                    }
                    else {
                        this.alertService.showMessage('Gas TTF 103', 'waarde bestaat al deze datum!', MessageSeverity.warn);
                    }
                }
            }, error => {
                const errorMessage = Utilities.findHttpResponseMessage("error_description", error);
            });
        }
    }

    getById() {
        
        this.loading = true;
        const getCustSubscriber = this.gasthreeService.getGasThreeById(this.gasthree.Id).subscribe((res: GasThree) => {
            if (res) {
                
                this.gasthree = res;
                this.EditValue = res.StripName;
                this.getKwartaalFromStripName();
                this.loading = false;
                this.subscribers.push(getCustSubscriber);
            }
            else {
                this.router.navigate(['gasthree']);
            }
        }, error => {
            this.ngxLogger.error(error.message);
            throw error;
        });
    }

    showErrorAlert(caption: string, message: string) {
        this.alertService.showMessage(caption, message, MessageSeverity.error);
    }

    ngOnDestroy(): void {
        if (this.subscribers) {
            this.subscribers.forEach(s => s.unsubscribe());
        }
    }

    get canmanagegasthree() {
        return this.accountService.userHasPermission(Permission.manageCustomersPermission);
    }

    //onStartDateChange(value: Date) {

    //    if (moment(value).isAfter(this.gasthree.Date)) {
    //        this.gasthree.Date = value;
    //    }

    //    if (moment(value).isAfter(this.gasthree.StripName)) {
    //        this.gasthree.StripName = value.toString();
    //    }
    //}

    onStripNameChange(value: Date) {

        if (moment(value).isAfter(this.gasthree.StripName)) {
            this.gasthree.StripName = value.toString();
        }
    }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/gas-three/gasthree-addupdate/gasthree-add-update.component.ts